import { PageSuspense } from "@/components/PageSuspense";
import { Outlet, type RouteObject } from "react-router-dom";

export const projectDetailsRoutes: RouteObject = {
    path: ":projectId",
    lazy: () =>
        import("@/routes/projects/details/ProjectDetailsLayout").then((m) => ({
            Component: m.ProjectDetailsLayout,
        })),
    // handle without a label so Breadcrumbs includes this route in the
    // crumb chain and falls back to the dynamic project-name label prop
    // instead of showing only the parent "Projects" crumb.
    handle: {},
    children: [
        {
            index: true,
            lazy: () =>
                import("@/routes/projects/details/ProjectIndexRoute").then((m) => ({
                    Component: m.ProjectIndexRoute,
                })),
        },
        {
            path: "settings",
            lazy: () =>
                import("@/routes/projects/details/ProjectSettingsPage").then((m) => ({
                    Component: m.ProjectSettingsPage,
                })),
            handle: {
                menuItem: {
                    label: "Settings",
                    to: "settings",
                    section: "project",
                },
            },
        },
        {
            path: "secrets",
            lazy: () =>
                import("@/routes/projects/details/ProjectSecretsPage").then((m) => ({
                    Component: m.ProjectSecretsPage,
                })),
            handle: {
                menuItem: {
                    label: "Secrets",
                    to: "secrets",
                    section: "project",
                },
            },
        },
        {
            path: "prebuilds",
            lazy: () =>
                import("@/routes/projects/details/ProjectPrebuildsPage").then((m) => ({
                    Component: m.ProjectPrebuildsPage,
                })),
            handle: {
                menuItem: {
                    label: "Prebuilds",
                    to: "prebuilds",
                    section: "project",
                },
            },
        },
        {
            path: "insights",
            lazy: () =>
                import("@/routes/projects/details/ProjectInsightsPage").then((m) => ({
                    Component: m.ProjectInsightsPage,
                })),
            handle: {
                menuItem: {
                    label: "Insights",
                    to: "insights",
                    section: "project",
                },
            },
        },
    ],
};

export const projectRoutes: RouteObject = {
    path: "projects",
    handle: {
        label: "Projects",
    },
    element: (
        <PageSuspense>
            <Outlet />
        </PageSuspense>
    ),
    children: [
        {
            index: true,
            lazy: () =>
                import("@/routes/projects/ProjectsPage").then((m) => ({
                    Component: m.ProjectsPage,
                })),
        },
        projectDetailsRoutes,
    ],
};
